import { gql } from '@apollo/client';

export const CREATE_TRACK_SHOP_THE_ITEM = gql`
    mutation createTrackShopTheItem($input: CreateTrackShopTheItemInput!) {
        createTrackShopTheItem(input: $input) {
            id
            taffiId
            itemId
            storeId
            creator
            created
            updated
            updater
        }
    }
`;
